/*!
 * Gitter Sidecar v1.5.0
 * https://sidecar.gitter.im/
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sidecar"] = factory();
	else
		root["sidecar"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _chat = __webpack_require__(2);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// We use a CommonJS export here so people don't have to `var Sidecar = require('gitter-sidecar').default`
	// See https://github.com/webpack/webpack/issues/706
	module.exports = _chat2.default; // This is the entry point for the npm standalone package

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BasicSymbol;
	
	// We return the native Symbol if available
	// Otherwise just give them a random string
	function BasicSymbol(description) {
	  if (typeof Symbol === 'function') {
	    return Symbol(description);
	  }
	
	  var randomString = Math.random().toString(36).substr(2, 8);
	  return description + randomString;
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _basicSymbolPonyfill = __webpack_require__(1);
	
	var _basicSymbolPonyfill2 = _interopRequireDefault(_basicSymbolPonyfill);
	
	var _customEventPonyfill = __webpack_require__(3);
	
	var _customEventPonyfill2 = _interopRequireDefault(_customEventPonyfill);
	
	var _elementStore = __webpack_require__(5);
	
	var _elementStore2 = _interopRequireDefault(_elementStore);
	
	var _chat = __webpack_require__(7);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _domUtility = __webpack_require__(4);
	
	var domUtility = _interopRequireWildcard(_domUtility);
	
	var _makeReadableCopy = __webpack_require__(6);
	
	var _makeReadableCopy2 = _interopRequireDefault(_makeReadableCopy);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var parseAttributeTruthiness = function parseAttributeTruthiness(value) {
	  if (value) {
	    var valueSanitized = value.trim().toLowerCase();
	    if (valueSanitized === 'true' || valueSanitized === '1') {
	      return true;
	    } else if (valueSanitized === 'false' || valueSanitized === '0') {
	      return false;
	    }
	  }
	
	  return value;
	};
	
	// Pass in a shape object of options and the element
	// and we will extend and properties available
	// NOTE: We will only look for keys present in `options` passed in
	var getDataOptionsFromElement = function getDataOptionsFromElement(options, element) {
	  if (!element) {
	    return options;
	  }
	
	  var newOptions = {};
	  Object.keys(options).forEach(function (optionKey) {
	    var attr = 'data-' + optionKey;
	    if (element.hasAttribute(attr)) {
	      var optionValue = element.getAttribute(attr);
	      newOptions[optionKey] = optionValue;
	    }
	  });
	
	  return _extends({}, options, newOptions);
	};
	
	// Helper method that detects whether an element was "activated"
	// Returns a function that you can execute to remove the listeners
	// Accibility in mind: click, spacebar, enter
	var spacebarKey = 32;
	var enterKey = 13;
	var elementOnActivate = function elementOnActivate(elements, cb) {
	  elements = (0, domUtility.default)(elements);
	
	  var handler = function handler(e) {
	    // If click or spacebar, or enter is pressed
	    if (e.type === 'click' || e.type === 'keydown' && (e.keyCode === spacebarKey || e.keyCode === enterKey)) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      cb.call.apply(cb, [this, e].concat(args));
	    }
	  };
	  domUtility.on(elements, 'click keydown', handler);
	
	  return function () {
	    domUtility.off(elements, 'click keydown', handler);
	  };
	};
	
	var embedGitterStyles = function embedGitterStyles() {
	  var elementStore = new _elementStore2.default();
	
	  //$('head')[0].insertAdjacentHTML('afterbegin', '<div></div>');
	
	  var style = elementStore.createElement('style');
	  style.type = 'text/css';
	  style.innerHTML = _chat2.default;
	
	  // Put it at the top of the head so others can override
	  domUtility.prependElementTo(style, (0, domUtility.default)('head')[0]);
	
	  return elementStore;
	};
	
	var embedGitterChat = function embedGitterChat(opts) {
	  var elementStore = new _elementStore2.default();
	
	  var targetElements = opts.targetElement;
	
	  targetElements.forEach(function (targetElement) {
	    var targetElementOpts = getDataOptionsFromElement(opts, targetElement);
	
	    if (targetElementOpts.room) {
	      var iframe = elementStore.createElement('iframe');
	      iframe.setAttribute('frameborder', '0');
	      iframe.src = '' + opts.host + targetElementOpts.room + '/~embed';
	      //iframe.src = `${opts.host}${targetElementOpts.room}/~chat`;
	
	      targetElement.appendChild(iframe);
	    } else {
	      console.error('Gitter Sidecar: No room specified for targetElement', targetElement);
	    }
	  });
	
	  return elementStore;
	};
	
	// chat: sidecar chat instance
	var addActionBar = function addActionBar(chat) {
	  var opts = chat.options;
	
	  var elementStore = new _elementStore2.default();
	
	  opts.targetElement.forEach(function (targetElement) {
	    var actionBar = elementStore.createElement('div');
	    actionBar.classList.add('gitter-chat-embed-action-bar');
	    // Prepend to the target
	    targetElement.insertBefore(actionBar, targetElement.firstChild);
	
	    // Add a couple buttons to the bar
	    // ------------------------------------
	
	    var popOutActionElement = elementStore.createElement('a');
	    // We don't combine the `classList` call because IE doesn't support it
	    popOutActionElement.classList.add('gitter-chat-embed-action-bar-item');
	    popOutActionElement.classList.add('gitter-chat-embed-action-bar-item-pop-out');
	    popOutActionElement.setAttribute('aria-label', 'Open Chat in Gitter.im');
	    popOutActionElement.setAttribute('href', '' + opts.host + opts.room);
	    popOutActionElement.setAttribute('target', '_blank');
	    popOutActionElement.setAttribute('rel', 'noopener');
	
	    actionBar.appendChild(popOutActionElement);
	
	    var collapseActionElement = elementStore.createElement('button');
	    // We don't combine the `classList` call because IE doesn't support it
	    collapseActionElement.classList.add('gitter-chat-embed-action-bar-item');
	    collapseActionElement.classList.add('gitter-chat-embed-action-bar-item-collapse-chat');
	    collapseActionElement.setAttribute('aria-label', 'Collapse Gitter Chat');
	    elementOnActivate(collapseActionElement, function (e) {
	      // Hide the chat
	      chat.toggleChat(false);
	
	      e.preventDefault();
	    });
	
	    actionBar.appendChild(collapseActionElement);
	  });
	
	  return elementStore;
	};
	
	var documentRootElement = document.body || document.documentElement;
	
	var defaults = {
	  room: undefined,
	  // Single or array of dom elements, or string selector to embed chat in
	  // Where you want to embed the chat
	  targetElement: undefined,
	  // Single or array of dom elements, or string selector to embed chat in
	  // The button element used to activate when the chat gets shown on the page
	  // Note: Only applies if `options.showChatByDefault` is `false`
	  activationElement: undefined,
	
	  // Whether to show the chat embed when the page loads
	  // Note: Use with caution, useful for use cases where you have a page dedicated to chat.
	  showChatByDefault: false,
	
	  // Whether to preload the gitter chat iframe.
	  // We preload the chat so there isn't any jank when the chat opens
	  preload: false,
	
	  // Whether to embed a `<style>` tag with some pre-made CSS
	  useStyles: true,
	  // TODO: implement layouts (see todo.md)
	  //   - `fixed`
	  //   - `off-canvas`
	  //   - `flex-aside`
	  layout: 'fixed',
	
	  //showLeftMenu: false
	
	  // Undocumented private options ;)
	  // Base URL of the gitter instance you are running
	  // We are not using a nice URL parser/formatter,
	  // so make sure to add the trailing slash so that concating goes smooth
	  host: 'https://gitter.im/'
	};
	
	// Keep some stuff behind symbols so people "can't" access the private data
	var DEFAULTS = (0, _basicSymbolPonyfill2.default)('DEFAULTS');
	var OPTIONS = (0, _basicSymbolPonyfill2.default)('OPTIONS');
	var ELEMENTSTORE = (0, _basicSymbolPonyfill2.default)('ELEMENTSTORE');
	var EVENTHANDLESTORE = (0, _basicSymbolPonyfill2.default)('EVENTHANDLESTORE');
	var INIT = (0, _basicSymbolPonyfill2.default)('INIT');
	var ISEMBEDDED = (0, _basicSymbolPonyfill2.default)('ISEMBEDDED');
	var EMBEDCHATONCE = (0, _basicSymbolPonyfill2.default)('EMBEDCHATONCE');
	var TOGGLETARGETELEMENTS = (0, _basicSymbolPonyfill2.default)('TOGGLETARGETELEMENTS');
	
	var chatEmbed = function () {
	  function chatEmbed() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, chatEmbed);
	
	    this[ELEMENTSTORE] = new _elementStore2.default();
	    this[EVENTHANDLESTORE] = [];
	
	    this[DEFAULTS] = defaults;
	    this[OPTIONS] = _extends({}, this[DEFAULTS], options);
	
	    this[INIT]();
	  }
	
	  _createClass(chatEmbed, [{
	    key: INIT,
	    value: function value() {
	      var _this = this;
	
	      var opts = this[OPTIONS];
	
	      if (opts.useStyles) {
	        this[ELEMENTSTORE].add(embedGitterStyles());
	      }
	
	      // Coerce into array of dom elements on what they pass in
	      // Otherwise create our own default targetElement
	      opts.targetElement = (0, domUtility.default)(opts.targetElement || function () {
	        var targetElement = _this[ELEMENTSTORE].createElement('aside');
	        targetElement.classList.add('gitter-chat-embed');
	        // Start out collapsed
	        targetElement.classList.add('is-collapsed');
	        documentRootElement.appendChild(targetElement);
	
	        return targetElement;
	      }());
	
	      opts.targetElement.forEach(function (targetElement) {
	        var loadingIndicatorElement = _this[ELEMENTSTORE].createElement('div');
	        loadingIndicatorElement.classList.add('gitter-chat-embed-loading-wrapper');
	        loadingIndicatorElement.innerHTML = '\n        <div class="gitter-chat-embed-loading-indicator gitter-icon"></div>\n      ';
	
	        // Prepend
	        targetElement.insertBefore(loadingIndicatorElement, targetElement.firstChild);
	      });
	
	      // Add the action bar to the target
	      // after it was put in place just above
	      addActionBar(this);
	
	      if (opts.preload) {
	        this.toggleChat(false);
	      }
	
	      if (opts.showChatByDefault) {
	        this.toggleChat(true);
	      }
	      // The activationElement is only setup if `opts.showChatByDefault` is false
	      else {
	          // Create our own default activationElement if one was not defined
	          // Note: You can pass `false` or `null` to disable the activation element
	          if (opts.activationElement === undefined || opts.activationElement === true) {
	            opts.activationElement = (0, domUtility.default)(function () {
	              var button = _this[ELEMENTSTORE].createElement('a');
	              // We use the option for the room (not pertaining to a particular targetElement attribute if set)
	              button.href = '' + opts.host + opts.room;
	              button.innerHTML = 'Open Chat';
	              button.classList.add('gitter-open-chat-button');
	              documentRootElement.appendChild(button);
	
	              return button;
	            }());
	          }
	          // Otherwise coerce into array of dom elements on what they pass in
	          else if (opts.activationElement) {
	              opts.activationElement = (0, domUtility.default)(opts.activationElement);
	            }
	
	          if (opts.activationElement) {
	            // Hook up the button to show the chat on activation
	            elementOnActivate(opts.activationElement, function (e) {
	              // Show the chat
	              _this.toggleChat(true);
	
	              e.preventDefault();
	            });
	
	            // Toggle the visibility of the activation element
	            // so it is only there when the the chat is closed
	            opts.targetElement.forEach(function (targetElement) {
	              domUtility.on(targetElement, 'gitter-chat-toggle', function (e) {
	                var isChatOpen = e.detail.state;
	
	                opts.activationElement.forEach(function (activationElement) {
	                  domUtility.toggleClass(activationElement, 'is-collapsed', isChatOpen);
	                });
	              });
	            });
	          }
	        }
	
	      // Listen to buttons with a class of `.js-gitter-toggle-chat-button`
	      // We also look for an options `data-gitter-toggle-chat-state` attribute
	      var classToggleButtonOff = elementOnActivate((0, domUtility.default)('.js-gitter-toggle-chat-button'), function (e) {
	        var state = parseAttributeTruthiness(e.target.getAttribute('data-gitter-toggle-chat-state'));
	        _this.toggleChat(state !== null ? state : 'toggle');
	
	        e.preventDefault();
	      });
	      this[EVENTHANDLESTORE].push(classToggleButtonOff);
	
	      // Emit that we started on each targetElement
	      opts.targetElement.forEach(function (targetElement) {
	        var event = new _customEventPonyfill2.default('gitter-chat-started', {
	          detail: {
	            chat: _this
	          }
	        });
	        targetElement.dispatchEvent(event);
	      });
	      // Emit that we started on the document
	      var documentEvent = new _customEventPonyfill2.default('gitter-sidecar-instance-started', {
	        detail: {
	          chat: this
	        }
	      });
	      document.dispatchEvent(documentEvent);
	    }
	  }, {
	    key: EMBEDCHATONCE,
	    value: function value() {
	      if (!this[ISEMBEDDED]) {
	        var opts = this[OPTIONS];
	
	        var embedResult = embedGitterChat(opts);
	        this[ELEMENTSTORE].add(embedResult);
	      }
	
	      this[ISEMBEDDED] = true;
	    }
	
	    // state: true, false, 'toggle'
	
	  }, {
	    key: TOGGLETARGETELEMENTS,
	    value: function value(state) {
	      var opts = this[OPTIONS];
	
	      if (!opts.targetElement) {
	        console.warn('Gitter Sidecar: No chat embed elements to toggle visibility on');
	      }
	
	      var targetElements = opts.targetElement;
	      targetElements.forEach(function (targetElement) {
	        if (state === 'toggle') {
	          domUtility.toggleClass(targetElement, 'is-collapsed');
	        } else {
	          domUtility.toggleClass(targetElement, 'is-collapsed', !state);
	        }
	
	        var event = new _customEventPonyfill2.default('gitter-chat-toggle', {
	          detail: {
	            state: state
	          }
	        });
	        targetElement.dispatchEvent(event);
	      });
	    }
	
	    // Public API
	
	  }, {
	    key: 'toggleChat',
	
	
	    // state: true, false, 'toggle'
	    value: function toggleChat(state) {
	      var _this2 = this;
	
	      var opts = this[OPTIONS];
	
	      // We delay the embed to make sure the animation can go jank free
	      // if it isn't already embedded
	      if (state && !this[ISEMBEDDED]) {
	        var targetElements = opts.targetElement;
	        // Start the loading spinner
	        targetElements.forEach(function (targetElement) {
	          targetElement.classList.add('is-loading');
	        });
	
	        setTimeout(function () {
	          _this2[EMBEDCHATONCE]();
	          _this2[TOGGLETARGETELEMENTS](state);
	
	          // Remove the loading spinner
	          targetElements.forEach(function (targetElement) {
	            targetElement.classList.remove('is-loading');
	          });
	        }, 300 /* TODO change to transition/animation end, see for robust transition/animation end code: https://github.com/MadLittleMods/jquery-carouselss */);
	      }
	      // But we still want people to embed no matter what state :)
	      // For example `options.preload`, should load the chat but not show it
	      else {
	          this[EMBEDCHATONCE]();
	          this[TOGGLETARGETELEMENTS](state);
	        }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      // Remove all the event handlers
	      this[EVENTHANDLESTORE].forEach(function (fn) {
	        fn();
	      });
	
	      //console.log(this[ELEMENTSTORE]);
	      // Remove and DOM elements, we made
	      this[ELEMENTSTORE].destroy();
	    }
	  }, {
	    key: 'options',
	    get: function get() {
	      // We don't want anyone to modify our options
	      // So copy and make it non-writable
	      return (0, _makeReadableCopy2.default)(this[OPTIONS]);
	    }
	  }]);
	
	  return chatEmbed;
	}();
	
	exports.default = chatEmbed;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CustomEvent;
	// via https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
	function CustomEvent(event, _ref) {
	  var _ref$bubbles = _ref.bubbles,
	      bubbles = _ref$bubbles === undefined ? false : _ref$bubbles,
	      _ref$cancelable = _ref.cancelable,
	      cancelable = _ref$cancelable === undefined ? false : _ref$cancelable,
	      _ref$detail = _ref.detail,
	      detail = _ref$detail === undefined ? undefined : _ref$detail;
	
	  var evt = void 0;
	  try {
	    evt = new window.CustomEvent(event, {
	      bubbles: bubbles,
	      cancelable: cancelable,
	      detail: detail
	    });
	  } catch (e) {
	    // For IE11-
	    evt = document.createEvent('CustomEvent');
	    evt.initCustomEvent(event, bubbles, cancelable, detail);
	  }
	
	  return evt;
	}
	
	CustomEvent.prototype = window.Event.prototype;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forEach = forEach;
	exports.on = on;
	exports.off = off;
	exports.prependElementTo = prependElementTo;
	exports.toggleClass = toggleClass;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// DOM Utility
	// https://gist.github.com/MadLittleMods/f71b0ef905832b8c16c9
	//
	// Inspired by bling.js: https://gist.github.com/paulirish/12fb951a8b893a454b32
	// But we needed full module encapsulation
	
	// This will concat anything including array-like things(like NodeLists or HTMLCollections)
	var concat = function concat() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.reduce(function (result, item) {
	    // If array-like
	    if (item && item.length !== undefined && !Array.isArray(item) && (
	    // The window object acts as an array of the iframes in the document (undesired effects for our use cases)
	    !window || window && !(item instanceof window.constructor))) {
	      item = Array.prototype.slice.call(item);
	    }
	
	    return result.concat(item);
	  }, []);
	};
	
	// Pass in a selector string, dom node, or array of dom nodes
	var coerceIntoElementsArray = function coerceIntoElementsArray() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var elements = args;
	  if (typeof args[0] === 'string') {
	    var _document$querySelect;
	
	    elements = (_document$querySelect = document.querySelectorAll).call.apply(_document$querySelect, [document].concat(args));
	  }
	
	  return concat.apply(undefined, _toConsumableArray(elements));
	};
	
	// `arrayLike` can be a single object, array, or array-like (NodeList, HTMLCollection)
	function forEach(arrayLike, cb) {
	  concat(arrayLike).forEach(function () {
	    if (cb) {
	      cb.apply(undefined, arguments);
	    }
	  });
	
	  // Keep the chaining going
	  return this;
	}
	
	// Listen to events.
	// Pass in a string name of events separated by spaces
	function on(elements, names, cb) {
	  names.split(/\s/).forEach(function (name) {
	    forEach(elements, function (element) {
	      element.addEventListener(name, cb);
	    });
	  });
	
	  // Keep the chaining going
	  return this;
	}
	
	// Remove the event listener
	// Pass in a string name of events separated by spaces
	function off(elements, names, cb) {
	  names.split(/\s/).forEach(function (name) {
	    forEach(elements, function (element) {
	      element.removeEventListener(name, cb);
	    });
	  });
	
	  // Keep the chaining going
	  return this;
	}
	
	function prependElementTo(element, target) {
	  var firstTargetChild = (target.children || [])[0];
	  if (firstTargetChild) {
	    target.insertBefore(element, firstTargetChild);
	  } else {
	    target.appendChild(element);
	  }
	}
	
	// Can't use `classList.toggle` with the second parameter (force)
	// Because IE11 does not support it
	function toggleClass(element, class1, force) {
	  if (force !== undefined) {
	    if (force) {
	      element.classList.add(class1);
	    } else {
	      element.classList.remove(class1);
	    }
	  } else {
	    element.classList.toggle(class1);
	  }
	
	  return force;
	}
	
	var $ = function $() {
	  return coerceIntoElementsArray.apply(undefined, arguments);
	};
	
	exports.default = $;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var remove = function remove(element) {
	  if (element) {
	    element.parentElement.removeChild(element);
	  }
	};
	
	var ElementStore = function () {
	  function ElementStore() {
	    _classCallCheck(this, ElementStore);
	
	    this.elements = [];
	  }
	
	  _createClass(ElementStore, [{
	    key: "createElement",
	    value: function createElement() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var element = document.createElement.apply(document, args);
	      this.add(element);
	      return element;
	    }
	  }, {
	    key: "add",
	    value: function add() {
	      for (var _len2 = arguments.length, elements = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        elements[_key2] = arguments[_key2];
	      }
	
	      var flattenedElements = [].concat(elements).reduce(function (prevResult, element) {
	        if (element) {
	          // If it is a store, flatten it out into us
	          if (element instanceof ElementStore) {
	            return prevResult.concat(element.elements);
	          }
	
	          return prevResult.concat(element);
	        }
	
	        return prevResult;
	      }, []);
	
	      this.elements = this.elements.concat(flattenedElements);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this.elements.forEach(function (element) {
	        return remove(element);
	      });
	      this.elements = [];
	    }
	  }]);
	
	  return ElementStore;
	}();
	
	exports.default = ElementStore;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeReadableCopy;
	// Copy a JS object and make it read-only
	function makeReadableCopy(obj) {
	  var clone = {};
	  Object.keys(obj).forEach(function (key) {
	    Object.defineProperty(clone, key, {
	      value: obj[key],
	      writable: false,
	      configurable: false
	    });
	  });
	
	  return clone;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(8)();
	// imports
	
	
	// module
	exports.push([module.id, ".gitter-hidden{box-sizing:border-box;display:none}.gitter-icon{box-sizing:border-box;width:22px;height:22px;fill:currentColor}.gitter-chat-embed{box-sizing:border-box;z-index:100;position:fixed;top:0;left:60%;bottom:0;right:0;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;background-color:#fff;border-left:1px solid #333;box-shadow:-12px 0 18px 0 rgba(50,50,50,.3);transition:transform .3s cubic-bezier(.16,.22,.22,1.7)}@context border-box{.gitter-chat-embed{box-sizing:border-box;background-color:#fff}}.gitter-chat-embed.is-collapsed:not(.is-loading){box-sizing:border-box;transform:translateX(110%)}.gitter-chat-embed:after{box-sizing:border-box;content:\"\";z-index:-1;position:absolute;top:0;left:100%;bottom:0;right:-100%;background-color:#fff}@context border-box{.gitter-chat-embed:after{box-sizing:border-box;background-color:#fff}}@media(max-width:1150px){.gitter-chat-embed{box-sizing:border-box;left:45%}}@media(max-width:944px){.gitter-chat-embed{box-sizing:border-box;left:30%}}@media(max-width:600px){.gitter-chat-embed{box-sizing:border-box;left:15%}}@media(max-width:500px){.gitter-chat-embed{box-sizing:border-box;left:0;border-left:none}}.gitter-chat-embed>iframe{box-sizing:border-box;-ms-flex:1;flex:1;width:100%;height:100%;border:0}.gitter-chat-embed-loading-wrapper{box-sizing:border-box;position:absolute;top:0;left:0;bottom:0;right:0;display:none;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.is-loading .gitter-chat-embed-loading-wrapper{box-sizing:border-box;display:-ms-flexbox;display:flex}.gitter-chat-embed-loading-indicator{box-sizing:border-box;opacity:.75;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNzkyIDE3OTIiIGZpbGw9IiMzYTMxMzMiPjxwYXRoIGQ9Ik01MjYgMTM5NHEwIDUzLTM3LjUgOTAuNXQtOTAuNSAzNy41cS01MiAwLTkwLTM4dC0zOC05MHEwLTUzIDM3LjUtOTAuNXQ5MC41LTM3LjUgOTAuNSAzNy41IDM3LjUgOTAuNXptNDk4IDIwNnEwIDUzLTM3LjUgOTAuNXQtOTAuNSAzNy41LTkwLjUtMzcuNS0zNy41LTkwLjUgMzcuNS05MC41IDkwLjUtMzcuNSA5MC41IDM3LjUgMzcuNSA5MC41em0tNzA0LTcwNHEwIDUzLTM3LjUgOTAuNXQtOTAuNSAzNy41LTkwLjUtMzcuNS0zNy41LTkwLjUgMzcuNS05MC41IDkwLjUtMzcuNSA5MC41IDM3LjUgMzcuNSA5MC41em0xMjAyIDQ5OHEwIDUyLTM4IDkwdC05MCAzOHEtNTMgMC05MC41LTM3LjV0LTM3LjUtOTAuNSAzNy41LTkwLjUgOTAuNS0zNy41IDkwLjUgMzcuNSAzNy41IDkwLjV6bS05NjQtOTk2cTAgNjYtNDcgMTEzdC0xMTMgNDctMTEzLTQ3LTQ3LTExMyA0Ny0xMTMgMTEzLTQ3IDExMyA0NyA0NyAxMTN6bTExNzAgNDk4cTAgNTMtMzcuNSA5MC41dC05MC41IDM3LjUtOTAuNS0zNy41LTM3LjUtOTAuNSAzNy41LTkwLjUgOTAuNS0zNy41IDkwLjUgMzcuNSAzNy41IDkwLjV6bS02NDAtNzA0cTAgODAtNTYgMTM2dC0xMzYgNTYtMTM2LTU2LTU2LTEzNiA1Ni0xMzYgMTM2LTU2IDEzNiA1NiA1NiAxMzZ6bTUzMCAyMDZxMCA5My02NiAxNTguNXQtMTU4IDY1LjVxLTkzIDAtMTU4LjUtNjUuNXQtNjUuNS0xNTguNXEwLTkyIDY1LjUtMTU4dDE1OC41LTY2cTkyIDAgMTU4IDY2dDY2IDE1OHoiLz48L3N2Zz4=);animation:spin 2s infinite linear}@keyframes spin{0%{box-sizing:border-box;transform:rotate(0deg)}to{box-sizing:border-box;transform:rotate(359.9deg)}}.gitter-chat-embed-action-bar{box-sizing:border-box;position:absolute;top:0;left:0;right:0;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding-bottom:.7em;background:linear-gradient(180deg,#fff 0,#fff 50%,hsla(0,0%,100%,0))}.gitter-chat-embed-action-bar-item{box-sizing:border-box;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:40px;height:40px;padding-left:0;padding-right:0;opacity:.65;background:none;background-position:50%;background-repeat:no-repeat;background-size:22px 22px;border:0;outline:none;cursor:pointer;cursor:hand;transition:all .2s ease}.gitter-chat-embed-action-bar-item:focus,.gitter-chat-embed-action-bar-item:hover{box-sizing:border-box;opacity:1}.gitter-chat-embed-action-bar-item:active{box-sizing:border-box;filter:hue-rotate(80deg) saturate(150)}.gitter-chat-embed-action-bar-item-pop-out{box-sizing:border-box;margin-right:-4px;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMTcxLjQyOSIgZmlsbD0iIzNhMzEzMyI+PHBhdGggZD0iTTE1Ny4xNDMsMTAzLjU3MXYzNS43MTRjMCw4Ljg1NC0zLjE0NCwxNi40MjYtOS40MzEsMjIuNzEzcy0xMy44NTgsOS40MzEtMjIuNzEyLDkuNDMxSDMyLjE0MyBjLTguODU0LDAtMTYuNDI1LTMuMTQ0LTIyLjcxMi05LjQzMVMwLDE0OC4xNCwwLDEzOS4yODVWNDYuNDI5YzAtOC44NTQsMy4xNDQtMTYuNDI1LDkuNDMxLTIyLjcxMiBjNi4yODctNi4yODcsMTMuODU4LTkuNDMxLDIyLjcxMi05LjQzMWg3OC41NzJjMS4wNDEsMCwxLjg5NiwwLjMzNSwyLjU2NiwxLjAwNGMwLjY3LDAuNjcsMS4wMDQsMS41MjUsMS4wMDQsMi41NjdWMjUgYzAsMS4wNDItMC4zMzQsMS44OTctMS4wMDQsMi41NjdjLTAuNjcsMC42Ny0xLjUyNSwxLjAwNC0yLjU2NiwxLjAwNEgzMi4xNDNjLTQuOTExLDAtOS4xMTUsMS43NDktMTIuNjEyLDUuMjQ2IHMtNS4yNDYsNy43MDEtNS4yNDYsMTIuNjEydjkyLjg1NmMwLDQuOTExLDEuNzQ5LDkuMTE1LDUuMjQ2LDEyLjYxMnM3LjcwMSw1LjI0NSwxMi42MTIsNS4yNDVIMTI1YzQuOTEsMCw5LjExNS0xLjc0OCwxMi42MTEtNS4yNDUgYzMuNDk3LTMuNDk3LDUuMjQ2LTcuNzAxLDUuMjQ2LTEyLjYxMnYtMzUuNzE0YzAtMS4wNDIsMC4zMzQtMS44OTcsMS4wMDQtMi41NjdjMC42Ny0wLjY2OSwxLjUyNS0xLjAwNCwyLjU2Ny0xLjAwNGg3LjE0MyBjMS4wNDIsMCwxLjg5NywwLjMzNSwyLjU2NywxLjAwNEMxNTYuODA5LDEwMS42NzQsMTU3LjE0MywxMDIuNTI5LDE1Ny4xNDMsMTAzLjU3MXogTTIwMCw3LjE0M3Y1Ny4xNDMgYzAsMS45MzUtMC43MDcsMy42MDktMi4xMjEsNS4wMjJjLTEuNDEzLDEuNDE0LTMuMDg4LDIuMTIxLTUuMDIxLDIuMTIxYy0xLjkzNSwwLTMuNjA5LTAuNzA3LTUuMDIyLTIuMTIxbC0xOS42NDQtMTkuNjQzIGwtNzIuNzY3LDcyLjc2OWMtMC43NDQsMC43NDQtMS42LDEuMTE1LTIuNTY3LDEuMTE1cy0xLjgyMy0wLjM3MS0yLjU2Ny0xLjExNUw3Ny41NjcsMTA5LjcxYy0wLjc0NC0wLjc0NC0xLjExNi0xLjYtMS4xMTYtMi41NjcgYzAtMC45NjcsMC4zNzItMS44MjIsMS4xMTYtMi41NjZsNzIuNzY4LTcyLjc2OGwtMTkuNjQ0LTE5LjY0M2MtMS40MTMtMS40MTQtMi4xMi0zLjA4OC0yLjEyLTUuMDIyYzAtMS45MzUsMC43MDctMy42MDksMi4xMi01LjAyMiBDMTMyLjEwNSwwLjcwNywxMzMuNzc5LDAsMTM1LjcxNSwwaDU3LjE0M2MxLjkzNCwwLDMuNjA4LDAuNzA3LDUuMDIxLDIuMTIxQzE5OS4yOTMsMy41MzQsMjAwLDUuMjA4LDIwMCw3LjE0M3oiLz48L3N2Zz4=)}.gitter-chat-embed-action-bar-item-collapse-chat{box-sizing:border-box;background-image:url(data:image/svg+xml;base64,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)}.gitter-open-chat-button{z-index:100;position:fixed;bottom:0;right:10px;padding:1em 3em;background-color:#36bc98;border:0;border-top-left-radius:.5em;border-top-right-radius:.5em;font-family:sans-serif;font-size:12px;letter-spacing:1px;text-transform:uppercase;text-align:center;text-decoration:none;cursor:pointer;cursor:hand;transition:all .3s ease}.gitter-open-chat-button,.gitter-open-chat-button:visited{box-sizing:border-box;color:#fff}.gitter-open-chat-button:focus,.gitter-open-chat-button:hover{box-sizing:border-box;background-color:#3ea07f;color:#fff}.gitter-open-chat-button:focus{box-sizing:border-box;box-shadow:0 0 8px rgba(62,160,127,.6);outline:none}.gitter-open-chat-button:active{box-sizing:border-box;color:#eee}.gitter-open-chat-button.is-collapsed{box-sizing:border-box;transform:translateY(120%)}", ""]);
	
	// exports


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// sidecar-module.js